<app-side-nav>
<router-outlet></router-outlet>
</app-side-nav>